import AdminDashboard from "@/pages/admin/index.vue";

import Company from "@/pages/admin/company/Parent.vue";
import CompanyList from "@/pages/admin/company/Company.vue";
import AddCompany from "@/pages/admin/company/AddCompany.vue";
import EditCompany from "@/pages/admin/company/EditCompany.vue";
import CompanyStatistics from "@/pages/admin/company/CompanyStatistics.vue";
import CompanyDetails from "@/pages/admin/company/CompanyDetails.vue";

import AccountManager from "@/pages/admin/account_manager/Parent.vue";
import AccountManagerList from "@/pages/admin/account_manager/AccountManager.vue";
import AddAccountManager from "@/pages/admin/account_manager/AddAccountManager.vue";
import EditAccountManager from "@/pages/admin/account_manager/EditAccountManager.vue";
import ViewAccountManager from "@/pages/admin/account_manager/ViewAccountManager.vue";

import AccountAdmin from "@/pages/admin/account_admin/Parent.vue";
import AccountAdminList from "@/pages/admin/account_admin/AccountAdmin.vue";
import AddAccountAdmin from "@/pages/admin/account_admin/AddAccountAdmin.vue";
import EditAccountAdmin from "@/pages/admin/account_admin/EditAccountAdmin.vue";

import Subscription from "@/pages/admin/subscription/Subscription.vue";

import SupportUserTicket from "@/pages/admin/support/Parent.vue";
import SupportUserTicketList from "@/pages/admin/support/SupportUserTicket.vue";
import AddSupportUserTicket from "@/pages/admin/support/AddSupportUserTicket.vue";
import SupportUserTicketView from "@/pages/admin/support/SupportUserTicketView.vue";

import SupportUser from "@/pages/admin/support_user/Parent.vue";
import SupportUserList from "@/pages/admin/support_user/SupportUser.vue";
import AddSupportUser from "@/pages/admin/support_user/AddSupportUser.vue";
import EditSupportUser from "@/pages/admin/support_user/EditSupportUser.vue";
import { checkifLoggedIn } from "@/utils/functions";

import Announcement from "@/pages/admin/announcement/Parent.vue";
import AnnouncementList from "@/pages/admin/announcement/Announcement.vue";
import AddAnnouncement from "@/pages/admin/announcement/AddAnnouncement.vue";
import EditAnnouncement from "@/pages/admin/announcement/EditAnnouncement.vue";

import VehicleType from "@/pages/admin/configuration/vehicle-type/Parent.vue";
import VehicleTypeList from "@/pages/admin/configuration/vehicle-type/VehicleType.vue";
import LicenseType from "@/pages/admin/configuration/license-type/Parent.vue";
import LicenseTypeList from "@/pages/admin/configuration/license-type/LicenseType.vue";
import PermitType from "@/pages/admin/configuration/permit-type/Parent.vue";
import PermitTypeList from "@/pages/admin/configuration/permit-type/PermitType.vue";

import CustomField from "@/pages/admin/custom_field/Parent.vue";
import CustomFieldList from "@/pages/admin/custom_field/CustomField.vue";
import AddCustomField from "@/pages/admin/custom_field/AddCustomField.vue";
import EditCustomField from "@/pages/admin/custom_field/EditCustomField.vue";

export default [
  {
    path: "admin-dashboard",
    name: "admin-dashboard",
    component: AdminDashboard,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
    },
  },
  {
    path: "company",
    name: "company",
    component: Company,
    redirect: { name: "company-list" },
    children: [
      {
        path: "list",
        name: "company-list",
        component: CompanyList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-company",
        component: AddCompany,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "edit/:id",
        name: "edit-company",
        component: EditCompany,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "view/:id",
        name: "view-company",
        component: CompanyDetails,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "statistics/:id",
        name: "company-statistics",
        component: CompanyStatistics,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "account_manager",
    name: "account-manager",
    component: AccountManager,
    redirect: { name: "account-manager-list" },
    children: [
      {
        path: "list",
        name: "account-manager-list",
        component: AccountManagerList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-account-manager",
        component: AddAccountManager,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "edit/:id",
        name: "edit-account-manager",
        component: EditAccountManager,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "view/:id",
        name: "view-account-manager",
        component: ViewAccountManager,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "account_admin",
    name: "account-admin",
    component: AccountAdmin,
    redirect: { name: "account-admin-list" },
    children: [
      {
        path: "list",
        name: "account-admin-list",
        component: AccountAdminList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-account-admin",
        component: AddAccountAdmin,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "edit/:id",
        name: "edit-account-admin",
        component: EditAccountAdmin,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "announcement",
    name: "announcement",
    component: Announcement,
    redirect: { name: "announcement-list" },
    children: [
      {
        path: "list",
        name: "announcement-list",
        component: AnnouncementList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-announcement",
        component: AddAnnouncement,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "edit/:id",
        name: "edit-announcement",
        component: EditAnnouncement,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "subsciption",
    name: "subsciption",
    component: Subscription,
    beforeEnter: (to, from, next) => {
      if (checkifLoggedIn()) next();
      else next({ name: "login" });
    },
  },
  {
    path: "vehicle-type",
    name: "vehicle-type",
    component: VehicleType,
    redirect: { name: "vehicle-type-list" },
    children: [
      {
        path: "vehicle-type-list",
        name: "vehicle-type-list",
        component: VehicleTypeList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "license-type",
    name: "license-type",
    component: LicenseType,
    redirect: { name: "license-type-list" },
    children: [
      {
        path: "license-type-list",
        name: "license-type-list",
        component: LicenseTypeList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "permit-type",
    name: "permit-type",
    component: PermitType,
    redirect: { name: "permit-type-list" },
    children: [
      {
        path: "permit-type-list",
        name: "permit-type-list",
        component: PermitTypeList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "support_user",
    name: "support-user",
    component: SupportUser,
    redirect: { name: "support-user-list" },
    children: [
      {
        path: "list",
        name: "support-user-list",
        component: SupportUserList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-support-user",
        component: AddSupportUser,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "edit/:id",
        name: "edit-support-user",
        component: EditSupportUser,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "support-user-ticket",
    name: "support-user-ticket",
    component: SupportUserTicket,
    redirect: { name: "support-user-ticket-list" },
    children: [
      {
        path: "list",
        name: "support-user-ticket-list",
        component: SupportUserTicketList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "view/:id",
        name: "support-user-ticket-view",
        component: SupportUserTicketView,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-support-user-ticket",
        component: AddSupportUserTicket,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
  {
    path: "custom_field",
    name: "custom-field",
    component: CustomField,
    redirect: { name: "custom-field-list" },
    children: [
      {
        path: "list",
        name: "custom-field-list",
        component: CustomFieldList,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "add",
        name: "add-custom-field",
        component: AddCustomField,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
      {
        path: "edit/:id",
        name: "edit-custom-field",
        component: EditCustomField,
        beforeEnter: (to, from, next) => {
          if (checkifLoggedIn()) next();
          else next({ name: "login" });
        },
      },
    ],
  },
];
